export class ParentSkuMappingItemModel {
    sku: string;
    amount: number;
}


